<template>
  <form class="form" method="put">

    <div id="appProductEditVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <div class="appProductEditShortcut">
          <p>Quantité :</p>
          <p id="appProductEditQuantityId">0</p>
        </div>
        <div class=" appHomeLine">
          <button @click.prevent="addUnit()" class="appButtonModel2">+ 1</button>
          <button @click.prevent="removeUnit()" type="submit" class="appButtonModel2">- 1</button>
        </div>
        <br>
        <h2>Modifier mon produit</h2>
        <button @click.prevent="modifyProduct()" type="submit" class="appButtonModel2">Valider</button>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Marque*</p>
            <p class="appLabelStyle1">Catégorie*</p>
            <p class="appLabelStyle1">Désignation*</p>
            <p class="appLabelStyle1">Prix Achat</p>
            <p class="appLabelStyle1">Prix Vente</p>
            <p class="appLabelStyle1">Quantité</p>
          </div>
          <div class="appGroupOfInput">
            <input v-model="product.marque" type="string" name="marque" class="appInputStyle1">
            <input v-model="product.category" type="string" name="category" class="appInputStyle1">
            <input v-model="product.name" type="string" name="name" class="appInputStyle1">
            <input v-model="product.priceBuyer" type="number" step=".01" name="priceBuyer" class="appInputStyle1">
            <input v-model="product.priceSeller" type="number" step=".01" name="priceSeller" class="appInputStyle1">
            <input v-model="product.quantity" type="number" name="quantity" class="appInputStyle1">
          </div>
        </div>
      </div>
      <br>
      <button @click.prevent="modifyProduct()" type="submit" class="appButtonModel2">Valider</button>
      <button @click.prevent="deleteProduct()" type="submit" class="appButtonModel2">Supprimer mon produit</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
      <div class="appNote01">
        <p>Note : Un produit sans prix de vente ne peut être sélectionné dans un encaissement</p>
      </div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ProductEdit',
  data () {
    return {
      marque: '',
      category: '',
      name: '',
      quantity: '',
      priceBuyer: '',
      priceSeller: '',
      errorMsg: '',
      product: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/produits/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.product = response.data
        this.showStock()
      })
  },
  methods: {
    showStock () {
      document.getElementById('appProductEditQuantityId').innerText = this.product.quantity
    },
    addUnit () {
      this.product.quantity += 1
      this.showStock()
    },
    removeUnit () {
      this.product.quantity -= 1
      this.showStock()
    },
    modifyProduct () {
      // Test si champs remplis
      if (this.marque !== null || this.category !== null || this.name !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage + ID produit
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        const url = document.location.href
        const idToModify = url.substring(url.lastIndexOf('=') + 1)
        axios
          .put('https://privilegia.fr/api/produits/' + idToModify,
            {
              'userId': decryptedToken.userId,
              'marque': this.product.marque.toUpperCase(),
              'category': this.product.category,
              'name': this.product.name,
              'quantity': this.product.quantity,
              'priceBuyer': this.product.priceBuyer,
              'priceSeller': this.product.priceSeller
            }, { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            this.$router.push('/App/Products')
          })
          .catch((error) => {
            this.errorMsg = 'Merci de renseigner au minimum la Marque, Catégorie et Désignation'
            console.log(error.response.data)
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner au minimum la Marque, Catégorie et Désignation'
      }
    },
    deleteProduct () {
      if (window.confirm('Supprimer ce produit ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const url = document.location.href
        const idToDelete = url.substring(url.lastIndexOf('=') + 1)
        axios
          .delete('https://privilegia.fr/api/produits/' + idToDelete,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Produit supprimé')
            this.$router.push('/App/Products')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppProductsEdit.vue